
// region JS Imports

// region External Modules
import Promise from "plugins/bluebird"
// endregion External Modules

// Private Modules
// Private Modules

// region Public Components
import Carousel from "concepts/listings/carousel"
import $ from "jquery"
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


function init_with_promise(): Promise<void> {
  return new Promise((resolve) => {
    Carousel.init()

    $(".overlay-fullscreen.cell-listing-carousel").each((idx, el) => {
      Carousel.init_one_element_with_promise({
        container_element:          el,
        listing_carousel_selector:  {
          carousel: ".carousel",
        },
        disable_init_protection:    true,
      }).done()
    })

    resolve()
  })
}


export default {
  init_with_promise,
}
export {
  init_with_promise,
}
